import React from 'react';
import { helpers, types } from 'helpers';

const Store = React.createContext({} as types.StoreInterface);

export const StoreProvider = (props: {
    children: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactPortal | null | undefined;
}) => {

    const uzer: types.User = helpers.isJson(helpers.getStorageJson('auth').user) ? JSON.parse(helpers.getStorageJson('auth').user) : {};
    const tokin = helpers.isJson(helpers.getStorageJson('auth').token) ? JSON.parse(helpers.getStorageJson('auth').token) : '';
    const buziness: types.Business = helpers.isJson(helpers.getStorageJson('auth').business) ? JSON.parse(helpers.getStorageJson('auth').business) : { keys: [] };

    const [user, setUser] = React.useState<types.User>(uzer);
    const [token, setToken] = React.useState(tokin);
    // eslint-disable-next-line
    const [_utils, _] = React.useState({
        env: (helpers.getStorage('env') || 'live') as 'test' | 'live',
        limit: 12,
        loading: {
            primary: '',
            spinning: false,
            secondary: '',
        }
    });
    const [_data, setData] = React.useState({
        key: (buziness.keys || [])[0],
        business: buziness,
    });

    const _store = { _auth: { user, token }, _utils, _data };

    const _setUser = (value: types.User) => {
        const auth = helpers.getStorageJson('auth');
        const usar: types.Business = helpers.isJson(auth.user) ? JSON.parse(auth.user) : {};
        const newData = { ...usar, ...value };
        auth['user'] = JSON.stringify(newData);
        setUser(newData);
        helpers.setStorageJson('auth', auth);
    }

    const _setBusiness = (value: types.Business) => {
        const auth = helpers.getStorageJson('auth');
        const usar: types.Business = helpers.isJson(auth.business) ? JSON.parse(auth.business) : {};
        const newdata = { ...usar, ...value };
        auth['business'] = JSON.stringify(newdata);
        setData((prevState) => ({ ...prevState, business: value, }));
        helpers.setStorageJson('auth', auth);
    }

    const _setToken = (value: string) => {
        const auth = helpers.getStorageJson('auth');
        auth['token'] = JSON.stringify(value);
        setToken(value);
        helpers.setStorageJson('auth', auth);
    }

    const _setAuth = (value: { user: types.User; token: string }) => {
        _setUser(value.user);
        _setToken(value.token);
    }

    // const _setUtils = (payload: { key: string, value: any }) => {
    //     const { key, value } = payload;
    //     if (typeof value === 'string') {
    //         helpers.setStorage(key, value);
    //         setUtils((prevState) => ({ ...prevState, [key]: value, }));
    //     } else {
    //         helpers.setStorageJson(key, value);
    //         setUtils((prevState) => ({ ...prevState, [key]: { ...prevState[key as keyof typeof prevState] as object, ...value }, }));
    //     }
    // }

    const _setData = (payload: { key: string, value: any }) => {
        const { key, value } = payload;
        if (typeof value === 'string') {
            helpers.setStorage(key, value);
            setData((prevState) => ({ ...prevState, [key]: value, }));
        } else {
            helpers.setStorageJson(key, value);
            setData((prevState) => ({ ...prevState, [key]: { ...prevState[key as keyof typeof prevState] as object, ...value }, }));
        }
    }

    return (
        <Store.Provider value={{ _store, _setAuth, _setUser, _setToken, _setBusiness, _setData }}>
            {props.children}
        </Store.Provider>
    );

}

export default Store;